import { useMemo } from "react";

import { groupBy, meanBy } from "lodash";

import { getClosestGrade } from "../../../utils/reviewUtils";
import { AnswerFragment } from '../../../graphql/generated/definitions';

export default function useLastUserGradeChartData(
  answers: AnswerFragment[],
  options: { value: number; label: string }[]
) {
  return useMemo(() => {
    if (answers && answers.length > 0) {
      const answersPerUsers = groupBy(answers, "isCollaborator");
      const collaborators = answersPerUsers["true"] || []; // FIXME quick fix pour eviter le plantage avec les standalones
      const referents = answersPerUsers["false"]?.filter((answer) => !!answer.normalizedRating) || [];

      return collaborators.flatMap(({ user, normalizedRating, createdAt }) => {
        const datumBase = {
          user: user.name,
          userId: user.id,
          date: new Date(createdAt).getTime(),
        };

        const referentsGrade = groupBy(referents, "collaborator.id")?.[user.id];

        return [
          {
            ...datumBase,
            gradeType: "collaborator",
            grade: normalizedRating,
          },
          {
            ...datumBase,
            gradeType: "referents",
            grade: referentsGrade
              ? getClosestGrade(
                  options,
                  meanBy(
                    groupBy(referents, "collaborator.id")?.[user.id],
                    "normalizedRating"
                  )
                ).value
              : null,
          },
        ];
      })
    }
    return null;
  }, [answers, options]);
}
